import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';

export const configDesktop = {
    tabOffset: {
        paddingTop: 24,
    } as IStyler,
};

export const configMobile = {
    tabOffset: {
        paddingTop: 16,
    } as IStyler,
};
